import fr from 'facet-rest';
import { BaseOverrideNoHidden } from 'Views/Page/Content/Templates/BaseOverride';

// This makes the common wizard step fields hidden by default since they are used in the base wizard template manually
export const BaseWizardStepOverride = fr.metaOverride({ base: BaseOverrideNoHidden })
  .nameOverride([
    'moduleName',
    'pretitle',
    'title',
    'subtitle',
    'primaryText',
    'secondaryText',
    'additionalDetailTitle',
    'additionalDetailItems',
    'attachmentButtonText',
    'body',
    'primaryActionLabel',
    'badgeImage',
    'badgeImageAlt',
    'imageUrl',
  ], {
    hidden: true,
  }).done();
